import { updateElements } from "./updateElements";

const waitForKiteAppDataAndUpdate = () => {
  const timeout = 30000;
  const interval = 500;
  const startTime = Date.now();

  const checkInterval = setInterval(() => {
    if (window.kite_app_data) {
      clearInterval(checkInterval);
      updateElements([".cart-drawer__line-items", ".cart-drawer__footer"]);
    } else if (Date.now() - startTime >= timeout) {
      clearInterval(checkInterval);
    }
  }, interval);
};

window.addEventListener("DOMContentLoaded", () => {
  waitForKiteAppDataAndUpdate();
});
